import axios from 'axios'
//TODO
import {CricrushConfig } from './../cc-imports'
import axiosRetry from './AxiosRetry';


const CCAxios = axios.create({
    baseURL: CricrushConfig.ccServiceBaseUrl,
    headers: {'Content-Type': 'application/json'}
});

axiosRetry(CCAxios, { retryDelay: axiosRetry.exponentialDelay, retries : 10000});


const CCAuthorizedAxios = ({accessToken}) => {
    var AuthAxios=  axios.create({
        baseURL: CricrushConfig.ccServiceBaseUrl,
        headers: {'Content-Type': 'application/json', 'access_token': accessToken}
    });

    axiosRetry(AuthAxios, { retryDelay: axiosRetry.exponentialDelay, retries : 10000});

    return AuthAxios;
};

export {CCAxios, CCAuthorizedAxios};


// WEBPACK FOOTER //
// ./src/app/lib/CCAxios.js